import { BrandShowroomAbout } from '../../services/modules/brand-showroom/brand-showroom.types';
import { empty2Null } from '../../utils/formatters';
import { isAdminTeceo } from '../context/ApplicationContext/applicationContext.utils';
import { BrandAboutSectionFormValues } from './brandAboutSectionForm.schema';

export const buildBrandAboutPayload = (
  googlePlusUrl: string | null | undefined,
  values: BrandAboutSectionFormValues,
): BrandShowroomAbout => {
  const about: BrandShowroomAbout = {
    logoUrl: values.logoUrl,
    website: empty2Null(values.website),
    aboutMe: empty2Null(values.aboutMe),
    title: empty2Null(values.title),
    facebookUrl: empty2Null(values.facebookUrl),
    instagramUrl: empty2Null(values.instagramUrl.replace(/^@/, '')),
    twitterUrl: empty2Null(values.twitterUrl),
    pinterestUrl: empty2Null(values.pinterestUrl),
    googlePlusUrl: empty2Null(googlePlusUrl),
    youtubeUrl: empty2Null(values.youtubeUrl),
    wholesaleMediumPrice: empty2Null(values.wholesaleMediumPrice),
    segmentIds: values.segmentIds,
  };

  return isAdminTeceo() ? { ...about, commercialName: values.commercialName } : about;
};
